/*!
 * @pixi/filter-outline - v5.2.0
 * Compiled Fri, 24 Mar 2023 22:12:11 UTC
 *
 * @pixi/filter-outline is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */import{Filter as l,utils as a}from"@pixi/core";var u=`attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`,c=`varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 filterClamp;

uniform float uAlpha;
uniform vec2 uThickness;
uniform vec4 uColor;
uniform bool uKnockout;

const float DOUBLE_PI = 2. * 3.14159265358979323846264;
const float ANGLE_STEP = \${angleStep};

float outlineMaxAlphaAtPos(vec2 pos) {
    if (uThickness.x == 0. || uThickness.y == 0.) {
        return 0.;
    }

    vec4 displacedColor;
    vec2 displacedPos;
    float maxAlpha = 0.;

    for (float angle = 0.; angle <= DOUBLE_PI; angle += ANGLE_STEP) {
        displacedPos.x = vTextureCoord.x + uThickness.x * cos(angle);
        displacedPos.y = vTextureCoord.y + uThickness.y * sin(angle);
        displacedColor = texture2D(uSampler, clamp(displacedPos, filterClamp.xy, filterClamp.zw));
        maxAlpha = max(maxAlpha, displacedColor.a);
    }

    return maxAlpha;
}

void main(void) {
    vec4 sourceColor = texture2D(uSampler, vTextureCoord);
    vec4 contentColor = sourceColor * float(!uKnockout);
    float outlineAlpha = uAlpha * outlineMaxAlphaAtPos(vTextureCoord.xy) * (1.-sourceColor.a);
    vec4 outlineColor = vec4(vec3(uColor) * outlineAlpha, outlineAlpha);
    gl_FragColor = contentColor + outlineColor;
}
`;const r=class extends l{constructor(o=1,t=0,n=.1,e=1,s=!1){super(u,c.replace(/\$\{angleStep\}/,r.getAngleStep(n))),this._thickness=1,this._alpha=1,this._knockout=!1,this.uniforms.uThickness=new Float32Array([0,0]),this.uniforms.uColor=new Float32Array([0,0,0,1]),this.uniforms.uAlpha=e,this.uniforms.uKnockout=s,Object.assign(this,{thickness:o,color:t,quality:n,alpha:e,knockout:s})}static getAngleStep(o){const t=Math.max(o*r.MAX_SAMPLES,r.MIN_SAMPLES);return(Math.PI*2/t).toFixed(7)}apply(o,t,n,e){this.uniforms.uThickness[0]=this._thickness/t._frame.width,this.uniforms.uThickness[1]=this._thickness/t._frame.height,this.uniforms.uAlpha=this._alpha,this.uniforms.uKnockout=this._knockout,o.applyFilter(this,t,n,e)}get alpha(){return this._alpha}set alpha(o){this._alpha=o}get color(){return a.rgb2hex(this.uniforms.uColor)}set color(o){a.hex2rgb(o,this.uniforms.uColor)}get knockout(){return this._knockout}set knockout(o){this._knockout=o}get thickness(){return this._thickness}set thickness(o){this._thickness=o,this.padding=o}};let i=r;i.MIN_SAMPLES=1,i.MAX_SAMPLES=100;export{i as OutlineFilter};
//# sourceMappingURL=filter-outline.mjs.map
